export const BANK_ACCOUNT_BALANCES_MUST_CHECK = 'bank_account_balances_must_check';
export const VAT_ENCASEMENT_IS_DEFINED_ON_ACCOUNTING_ENTRIES_IN_ENCASEMENT =
  'vat_encasement_is_defined_on_accounting_entries_in_encasement';

export const BALANCE_CONSISTENCY_CHECK_CODES = [VAT_ENCASEMENT_IS_DEFINED_ON_ACCOUNTING_ENTRIES_IN_ENCASEMENT];
export type BalanceConsistencyCheckCodes = (typeof BALANCE_CONSISTENCY_CHECK_CODES)[number];
